import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuccessResponse } from 'src/app/common/models/SuccessRespons';
import { environment as env } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ProposalService {
  private BASE_URL = `${env.PROPERTYBR_API_BASE_URL}/artico/proposal`;

  private BASE_URL_AR = `${env.ARTICO_API_BR_BASE_URL}/api/v1`;

  constructor(private httpClient: HttpClient) {}

  save(data: any) {
    const URL = this.BASE_URL;
    return this.httpClient.post<SuccessResponse>(URL, data);
  }

  update(data: any, id: string) {
    const URL = `${this.BASE_URL}/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  get(id: string) {
    const URL = `${this.BASE_URL}/find/${id}`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  remove(data: any, id: string) {
    const URL = `${this.BASE_URL}/remove/${id}`;
    return this.httpClient.put<SuccessResponse>(URL, data);
  }

  downloadProposal(proposalNumber: string) {
    const URL = `${this.BASE_URL_AR}/web/proposals/export/pdf/${proposalNumber}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(URL);
  }
}
